module.exports = __webpack_public_path__ + "img/Product Center.244f5aa3.png";